/* eslint-disable */
import { Loading, getResources } from 'react-admin';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import InvoicingReportFilters from './components/InvoicingReportFilters';
import ReportLayout from '../../base/components/reports/ReportLayout';
import InvoicingReportResults from './components/InvoicingReportResults';
import { REPORT_TYPES } from '../../constant';

export const LIST_REPORTS = [REPORT_TYPES.OVERALL, REPORT_TYPES.PREPAID, REPORT_TYPES.STANDARD];

function ReportInvoicingList({ resource, permissions, ...props }) {
  const originalResources = useSelector(getResources);

  const resources = useMemo(() => originalResources, [originalResources?.length]);

  if (!resources?.length) {
    return null;
  }

  const currentResource = resources.filter((r) => r.name === resource)?.[0];
  if (!currentResource) {
    return <Loading />;
  }

  const {
    options: { reportInterface },
  } = currentResource;

  return (
    <ReportLayout
      totalTables={LIST_REPORTS.length}
      filterChildren={<InvoicingReportFilters reportServiceVersion={reportInterface?.serviceVersion} />}
      resultChildren={<InvoicingReportResults />}
    />
  );
}

export default ReportInvoicingList;
